import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95343f28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "initial-container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { className: "text-container" }
const _hoisted_4 = { className: "title" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "form-content" }
const _hoisted_7 = { class: "top" }
const _hoisted_8 = { class: "inputs" }
const _hoisted_9 = { class: "bottom" }
const _hoisted_10 = { class: "checkbox-container" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filler" }, null, -1))

import Form from "@/components/layouts/Form.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import ReportErrorIconButton from "@/components/buttons/ReportErrorIconButton/ReportErrorIconButton.vue";
import MobileNavigationBar from "@/components/layouts/MobileNavigationBar/MobileNavigationBar.vue";
import { ActionTypes, MutationTypes } from "@/store";

import { handleOnboardingRedirect } from "@/utils/settings";
import {
  getInitialFormData,
  getIsFormValid,
  registerFormFields,
} from "@/utils/form";
import {
  FormFieldNameEnum,
  FormFieldType,
  FormType,
  RegisterFormDataObjectType,
} from "@/types/form";
import { computed, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { MobileNavigationBarIconType } from "@/types/app";
import { handleMountErrorMessageSnackbar } from "@/utils/app";
import { registerSnackbarErrorObject } from "@/utils/auth";
import { GenericButtonVariantEnum } from "@/types/button";
import { config } from "@/config";
import { IconType } from "@/types/icons";
import Icon from "../icons/Icon/Icon.vue";
import Input from "../forms/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterForm',
  setup(__props) {

const { commit, dispatch } = useStore();
const { t } = useI18n();

const data = reactive(
  getInitialFormData<RegisterFormDataObjectType>(registerFormFields),
);
const agreedToTermsAndConditions = ref(false);
const checkboxSrc = computed<IconType>(() =>
  agreedToTermsAndConditions.value
    ? IconType.CHECKBOX_ON
    : IconType.CHECKBOX_OFF,
);

const maitrejaAppUrl = config.api.maitrejaApi.appUrl;

const toggleCheckbox = () => {
  agreedToTermsAndConditions.value = !agreedToTermsAndConditions.value;
};

const handleSubmit = async () => {
  const { errors, ...fields } = data;

  const isFormValid = getIsFormValid(
    data,
    registerFormFields,
    FormType.Register,
  );
  if (!isFormValid) {
    return;
  }

  if (!agreedToTermsAndConditions.value) {
    dispatch(ActionTypes.MOUNT_SNACKBAR, {
      title: "snackbar.errors.agreeToTermsAndConditions.title",
      text: "snackbar.errors.agreeToTermsAndConditions.text",
    });
    return;
  }

  commit(MutationTypes.SET_IS_LOADING, true);
  try {
    await dispatch(ActionTypes.REGISTER_AUTH, {
      name: data.name,
      email: data.email,
      password: data.password,
    });

    data.errors = fields;
    handleOnboardingRedirect();
  } catch (error) {
    handleMountErrorMessageSnackbar(error, registerSnackbarErrorObject);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReportErrorIconButton),
    _createVNode(MobileNavigationBar, {
      "icon-type": _unref(MobileNavigationBarIconType).Circle
    }, null, 8, ["icon-type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("auth.registration")), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("auth.enterRequirements")), 1)
      ]),
      _createVNode(Form, { onSubmitForm: handleSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Input, {
                  modelValue: data.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.name) = $event)),
                  name: _unref(FormFieldNameEnum).Name,
                  placeholder: "auth.name",
                  required: "",
                  errors: data.errors
                }, null, 8, ["modelValue", "name", "errors"]),
                _createVNode(Input, {
                  modelValue: data.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.email) = $event)),
                  name: _unref(FormFieldNameEnum).Email,
                  placeholder: "auth.email",
                  required: "",
                  errors: data.errors
                }, null, 8, ["modelValue", "name", "errors"]),
                _createVNode(Input, {
                  modelValue: data.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.password) = $event)),
                  name: _unref(FormFieldNameEnum).Password,
                  type: _unref(FormFieldType).Password,
                  placeholder: "auth.password",
                  required: "",
                  errors: data.errors
                }, null, 8, ["modelValue", "name", "type", "errors"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(Icon, {
                    icon: checkboxSrc.value,
                    class: "checkbox",
                    onClick: toggleCheckbox
                  }, null, 8, ["icon"]),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("auth.businessConditions.iAgreeWith")) + " ", 1),
                    _createElementVNode("a", {
                      href: `${_unref(maitrejaAppUrl)}/content/gdpr`,
                      target: "_blank"
                    }, _toDisplayString(_unref(t)("auth.businessConditions.gdpr")), 9, _hoisted_11),
                    _createTextVNode(" " + _toDisplayString(_unref(t)("auth.businessConditions.and")) + " ", 1),
                    _createElementVNode("a", {
                      href: `${_unref(maitrejaAppUrl)}/content/conditions`,
                      target: "_blank"
                    }, _toDisplayString(_unref(t)("auth.businessConditions.conditions")), 9, _hoisted_12),
                    _createTextVNode(". ")
                  ])
                ])
              ])
            ]),
            _createVNode(GenericButton, {
              variant: _unref(GenericButtonVariantEnum).Primary,
              text: "auth.buttons.register"
            }, null, 8, ["variant"])
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_13
  ]))
}
}

})